<span fxLayout="row" fxLayoutAlign="space-between center" class="cell-issues-category-container">
  <span class="cell-issues-category-name">{{categoryName}}</span>
  <span class="issues-category-{{category}}"></span>
</span>